var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":"button","aria-label":_vm.$t('Show subcategories'),"data-testid":"categoryButton"}})
}
var staticRenderFns = []

export { render, staticRenderFns }